module.exports = __webpack_public_path__ + "static/media/5ed7a3c172f4e5e57a74878d.9a02214b.png";